/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Table_Header_PurposeInputs */

const en_privacy_table_header_purpose = /** @type {(inputs: Privacy_Table_Header_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purpose`)
};

const de_privacy_table_header_purpose = /** @type {(inputs: Privacy_Table_Header_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweck`)
};

const fr_privacy_table_header_purpose = /** @type {(inputs: Privacy_Table_Header_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalité`)
};

const es_privacy_table_header_purpose = /** @type {(inputs: Privacy_Table_Header_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalidad`)
};

const it_privacy_table_header_purpose = /** @type {(inputs: Privacy_Table_Header_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalità`)
};

const nl_privacy_table_header_purpose = /** @type {(inputs: Privacy_Table_Header_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doel`)
};

const pl_privacy_table_header_purpose = /** @type {(inputs: Privacy_Table_Header_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel`)
};

const fi_privacy_table_header_purpose = /** @type {(inputs: Privacy_Table_Header_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkoitus`)
};

const da_privacy_table_header_purpose = /** @type {(inputs: Privacy_Table_Header_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formål`)
};

const sv_privacy_table_header_purpose = /** @type {(inputs: Privacy_Table_Header_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syfte`)
};

/**
* | output |
* | --- |
* | "Purpose" |
*
* @param {Privacy_Table_Header_PurposeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_table_header_purpose = /** @type {((inputs?: Privacy_Table_Header_PurposeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Table_Header_PurposeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_table_header_purpose(inputs)
	if (locale === "fr") return fr_privacy_table_header_purpose(inputs)
	if (locale === "es") return es_privacy_table_header_purpose(inputs)
	if (locale === "it") return it_privacy_table_header_purpose(inputs)
	if (locale === "nl") return nl_privacy_table_header_purpose(inputs)
	if (locale === "pl") return pl_privacy_table_header_purpose(inputs)
	if (locale === "fi") return fi_privacy_table_header_purpose(inputs)
	if (locale === "da") return da_privacy_table_header_purpose(inputs)
	if (locale === "sv") return sv_privacy_table_header_purpose(inputs)
	return en_privacy_table_header_purpose(inputs)
});